import React from 'react';

import PropTypes from 'prop-types';
import {
    withRouter,
} from 'react-router';

import A from 'wanderu-component-react-router-link';
import { Button } from 'wanderu-components';
import { localize } from 'wanderu-i18n';
import {
    removeLanguagePath,
} from 'wanderu-utils';

import baseAppConfig from 'wanderu-shellapp/src/config/baseApp.locales';

import Events from '../events/AccountEvents';

import styles from './LogInButtons.scss';

// TODO: Figure out where to redirect after signup, currently goes to /account/mytrips/
const ACCOUNT_LOG_LINKS = [
    { href: '/account/signup', textKey: 'sign-up-button', seLabel: 'sign_up' },
    {
        href: '/account/login', textKey: 'log-in', outline: true, redirect: true, seLabel: 'log_in',
    },
];

function LogInButtons(props) {
    const {
        onClick,
        t,
        location,
        navType,
    } = props;

    const clickButton = (seLabel) => (e) => {
        onClick(e);
        Events.clicked({
            label: seLabel,
            navType,
        });
    };

    return (
        <div>
            {ACCOUNT_LOG_LINKS.map(({
                href, textKey, outline, redirect, seLabel,
            }) => {
                let redirectTo = null;
                if (redirect) {
                    redirectTo = removeLanguagePath(location.pathname) + location.search;
                }

                return (
                    <A
                        className={styles.buttonLink}
                        href={href}
                        key={href}
                        onClick={clickButton(seLabel)}
                        queries={{ redirectTo }}
                    >
                        <Button className={styles.button} outline={outline}>
                            {t(textKey)}
                        </Button>
                    </A>
                );
            })}
        </div>
    );
}

LogInButtons.propTypes = {
    onClick: PropTypes.func,
    t: PropTypes.func.isRequired,
    navType: PropTypes.string.isRequired,
};

LogInButtons.defaultProps = {
    onClick() {},
};

export { LogInButtons };
const LogInButtonsWithRouter = withRouter(LogInButtons);
export default localize(LogInButtonsWithRouter, ['t'], baseAppConfig.namespace);
